<div class="user-avatar-container">
  <div class="avatar" [ngClass]="avatarClass">
    {{ initials }}
  </div>
  <div class="details">
    <div class="name">{{ displayName }}</div>
    @if (displayEmail || displaySapId) {
      <div class="meta">
        @if (displayEmail) {
          <span>{{ displayEmail }}</span>
        }
        @if (displayEmail && displaySapId) {
          <span>&nbsp;&middot;&nbsp;</span>
        }
        @if (displaySapId) {
          <span> {{ displaySapId }}</span>
        }
      </div>
    }
  </div>
</div>
